import { LOGO_URL } from '@constants/Validation';
import { useAuth } from '@swyft/auth';
import { MainNavMenu as MainNavMenuSwyft } from '@swyft/ui';
import { useAppContext } from '@utils/appState';
import { parseJwt } from '@utils/parseJwt';
import React, { ReactElement } from 'react';

export const MainNavMenu = (): ReactElement => {
  const {
    state: {
      whiteLabelClient,
      companyInformation: { isEnabledSubscription }
    }
  } = useAppContext();

  const { isAuthenticated, signOut, user } = useAuth();

  const userName = React.useMemo(() => {
    if (user) {
      const payload = parseJwt(user.access_token);
      return payload.name;
    }
    return '';
  }, [user]);

  return (
    <MainNavMenuSwyft
      logoSrc={'/' + LOGO_URL}
      isAuthenticated={isAuthenticated}
      userName={userName}
      signOut={() => signOut()}
      noShowLogo={whiteLabelClient}
    >
      <div className='flex-grow' />
    </MainNavMenuSwyft>
  );
};
